import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = 'G-R23C8YE152';

export function initGA() {
  ReactGA.initialize(GA_MEASUREMENT_ID);
}

export function trackPageView(path) {
  ReactGA.send({ hitType: 'pageview', page: path });
}

export function trackEvent(category, action, label) {
  ReactGA.event({ category, action, label });
}
